export default __webpack_public_path__ + "static/media/05AW1SEP66.978d81b3.jpg";